module.exports = __webpack_public_path__ + "static/Bright.c45ce02a.png";